import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["value", "options", "onChange", "tagsWrapperClassName", "id", "shouldPassValuesToWrappedComponent", "areTagsDeletable"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { defaultMemoize } from 'reselect';

// Lodash
import _map from 'lodash/map';
import _without from 'lodash/without';
import _noop from 'lodash/noop';
import _uniq from 'lodash/uniq';
import _property from 'lodash/property';
import _filter from 'lodash/filter';
import _includes from 'lodash/includes';
import _isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEqual';
import _size from 'lodash/size';

// Utils
import { tget } from '@tekion/tekion-base/utils/general';

// Constants
import { EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';

// Components
import Tag from '../../../../atoms/Tag';

// Helpers
import { getSelectValues } from '../withBaseSelect/withBaseSelect.helpers';
import { isTagDeletable } from './helpers/withTags.general';

// Styles
import styles from './withTags.module.scss';
export default function (WrapperComponent) {
  var _class;
  return _class = /*#__PURE__*/function (_React$Component) {
    _inherits(_withTags, _React$Component);
    var _super = _createSuper(_withTags);
    function _withTags() {
      var _this;
      _classCallCheck(this, _withTags);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized(_this), "state", {
        selectedValues: []
      });
      _defineProperty(_assertThisInitialized(_this), "setInitialSelectedValues", function () {
        var _this$props = _this.props,
          options = _this$props.options,
          _this$props$value = _this$props.value,
          value = _this$props$value === void 0 ? EMPTY_ARRAY : _this$props$value,
          getOptionValue = _this$props.getOptionValue;
        var selectedOptions = _filter(options, function (option) {
          return _includes(value, getOptionValue(option));
        });
        _this.setState({
          selectedValues: selectedOptions
        });
      });
      _defineProperty(_assertThisInitialized(_this), "removeTag", function (value) {
        return function () {
          var _this$props2 = _this.props,
            currValue = _this$props2.value,
            onChange = _this$props2.onChange;
          onChange({
            value: _without(currValue, value)
          });
        };
      });
      _defineProperty(_assertThisInitialized(_this), "renderTag", function (selectValue, areTagsDeletable) {
        var _this$props3 = _this.props,
          getOptionLabel = _this$props3.getOptionLabel,
          getOptionValue = _this$props3.getOptionValue,
          isSelectValueDeletable = _this$props3.isSelectValueDeletable,
          tagClassName = _this$props3.tagClassName,
          tagContentClassName = _this$props3.tagContentClassName,
          TagRenderer = _this$props3.tagRenderer;

        // Handle garbage values
        if (!selectValue) {
          return null;
        }
        var label = getOptionLabel(selectValue);
        var value = getOptionValue(selectValue);
        var deletable = isTagDeletable({
          selectValue: selectValue,
          isSelectValueDeletable: isSelectValueDeletable,
          areTagsDeletable: areTagsDeletable
        });
        return /*#__PURE__*/React.createElement(TagRenderer, {
          className: cx(styles.tag, tagClassName),
          deletable: deletable,
          onDelete: _this.removeTag(value),
          value: selectValue,
          contentClassName: tagContentClassName
        }, label);
      });
      _defineProperty(_assertThisInitialized(_this), "onAddNewTag", function (_ref) {
        var value = _ref.value,
          option = _ref.option,
          eventDetails = _ref.eventDetails;
        var _this$props4 = _this.props,
          onChange = _this$props4.onChange,
          maxTagCount = _this$props4.maxTagCount;
        var currValue = tget(_this.props, 'value', EMPTY_ARRAY);
        var selectedValues = _this.state.selectedValues;
        if (_size(currValue) >= maxTagCount) return;
        _this.setState({
          selectedValues: [].concat(_toConsumableArray(selectedValues), [option])
        });
        onChange({
          value: _uniq([].concat(_toConsumableArray(currValue), _toConsumableArray(value))),
          option: option,
          eventDetails: eventDetails
        });
      });
      // passing areTagsDeletable here so that tags are also re-rendered when areTagsDeletable changes
      _defineProperty(_assertThisInitialized(_this), "renderTags", defaultMemoize(function (value, options, areTagsDeletable) {
        var getOptionValue = _this.props.getOptionValue;
        var values = _isEmpty(value) ? EMPTY_ARRAY : value;
        var selectedValues = getSelectValues(getOptionValue, options, values);
        return _map(selectedValues, function (selectedValue) {
          return _this.renderTag(selectedValue, areTagsDeletable);
        });
      }));
      return _this;
    }
    _createClass(_withTags, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.setInitialSelectedValues();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(previousProps) {
        var _this$props5 = this.props,
          options = _this$props5.options,
          value = _this$props5.value;
        var previousValues = previousProps.value,
          previousOptions = previousProps.options;
        var selectedValues = this.state.selectedValues;
        var isDataChanged = !_isEqual(previousValues, value) || !_isEqual(options, previousOptions);
        if (_isEmpty(selectedValues) && !_isEmpty(options) && !_isEmpty(value) && isDataChanged) {
          this.setInitialSelectedValues();
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props6 = this.props,
          value = _this$props6.value,
          options = _this$props6.options,
          onChange = _this$props6.onChange,
          tagsWrapperClassName = _this$props6.tagsWrapperClassName,
          id = _this$props6.id,
          shouldPassValuesToWrappedComponent = _this$props6.shouldPassValuesToWrappedComponent,
          areTagsDeletable = _this$props6.areTagsDeletable,
          rest = _objectWithoutProperties(_this$props6, _excluded);
        var selectedValues = this.state.selectedValues;
        return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(WrapperComponent, _extends({}, rest, {
          areTagsDeletable: areTagsDeletable,
          options: options,
          value: shouldPassValuesToWrappedComponent ? value : EMPTY_ARRAY,
          onChange: this.onAddNewTag
        })), /*#__PURE__*/React.createElement("div", {
          className: "".concat(cx(styles.tags, tagsWrapperClassName), " automation_selector_dropdown_tag_container_").concat(id)
        }, this.renderTags(value, selectedValues, areTagsDeletable)));
      }
    }]);
    return _withTags;
  }(React.Component), _defineProperty(_class, "propTypes", {
    value: PropTypes.arrayOf(PropTypes.string),
    onChange: PropTypes.func,
    getOptionLabel: PropTypes.func,
    getOptionValue: PropTypes.func,
    options: PropTypes.array,
    tagsWrapperClassName: PropTypes.string,
    isSelectValueDeletable: PropTypes.func,
    areTagsDeletable: PropTypes.bool,
    tagClassName: PropTypes.string,
    tagContentClassName: PropTypes.string,
    id: PropTypes.string,
    tagRenderer: PropTypes.element,
    shouldPassValuesToWrappedComponent: PropTypes.bool,
    maxTagCount: PropTypes.number
  }), _defineProperty(_class, "defaultProps", {
    value: EMPTY_ARRAY,
    onChange: _noop,
    getOptionLabel: _property('label'),
    getOptionValue: _property('value'),
    options: EMPTY_ARRAY,
    tagsWrapperClassName: '',
    tagClassName: '',
    tagContentClassName: '',
    isSelectValueDeletable: undefined,
    areTagsDeletable: true,
    id: '',
    tagRenderer: Tag,
    shouldPassValuesToWrappedComponent: false,
    maxTagCount: Number.MAX_SAFE_INTEGER
  }), _class;
}